/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Feat_GpsInputs */

const cs_pm_feat_gps = /** @type {(inputs: Pm_Feat_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poloha (GPS)`)
};

const en_pm_feat_gps = /** @type {(inputs: Pm_Feat_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location (GPS)`)
};

/**
* | output |
* | --- |
* | "Location (GPS)" |
*
* @param {Pm_Feat_GpsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_feat_gps = /** @type {((inputs?: Pm_Feat_GpsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Feat_GpsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_feat_gps(inputs)
	return cs_pm_feat_gps(inputs)
});